import { useState, useEffect } from "react";

export const useKeyPress = function (
  targetKey: string,
  ref: React.RefObject<any>
) {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const current = ref.current;

    const downHandler = ({ key }: { key: string }) =>
      key === targetKey && setKeyPressed(true);

    const upHandler = ({ key }: { key: string }) =>
      key === targetKey && setKeyPressed(false);

    current?.addEventListener("keydown", downHandler);
    current?.addEventListener("keyup", upHandler);

    return () => {
      current?.removeEventListener("keydown", downHandler);
      current?.removeEventListener("keyup", upHandler);
    };
  });

  return keyPressed;
};

export default useKeyPress;
